import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { filter, map, Observable, startWith } from 'rxjs';

import type { AppContextCollector } from '@core/tellent-assistant-contracts';

@Injectable({ providedIn: 'root' })
export class RouteContextCollector implements AppContextCollector {
  private readonly router = inject(Router);

  public readonly key = 'route';
  public readonly changes$: Observable<unknown>;

  constructor() {
    this.changes$ = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      startWith(null),
      map(() => this.parse(this.router.url)),
    );
  }

  public snapshot(): unknown {
    return this.parse(this.router.url);
  }

  private parse(url: string): {
    path: string;
    params: Record<string, string>;
    query: Record<string, string>;
  } {
    const [pathPart, queryPart = ''] = url.split('?');
    const query: Record<string, string> = {};
    for (const pair of queryPart.split('&').filter(Boolean)) {
      const [k, v = ''] = pair.split('=');
      query[decodeURIComponent(k)] = decodeURIComponent(v);
    }
    return { path: pathPart, params: {}, query };
  }
}
